export const cdnEntityOptionsKeys = ['referenceScheme'];
//# sourceMappingURL=cdn-entity-options.js.map